<template>
    <div>
        <b-row>
            <b-col cols="6">
                <b-form-group :label="$t('academic_year')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.academic_year) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group :label="$t('session')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.session_name) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group :label="$t('start_date')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.start_date) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group :label="$t('end_date')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.end_date) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group :label="$t('course_registration_start_date')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.course_registration_start_date) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group :label="$t('course_registration_end_date')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.course_registration_end_date) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group :label="$t('late_registration_start_date')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.late_registration_start_date) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    //Service
    import EslModuleDateService from '@/services/EslModuleDateService';

    export default {
        props: {
            formId: {
                type: Number
            }
        },
        data() {
            return {
                form: {
                    academic_year: null,
                    session_name: null,
                    start_date: null,
                    end_date: null,
                    course_registration_start_date: null,
                    course_registration_end_date: null,
                    late_registration_start_date: null,
                }
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                this.formLoading = true;
                EslModuleDateService.get(id)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.formLoading = false;
                                })
                                .catch((error) => {
                                    this.showErrors(error)
                                });
            }
        }
    }
</script>
